// extracted by mini-css-extract-plugin
export default {"root":"OurMission_root__6Wsov","title":"OurMission_title__ydTpJ","block":"OurMission_block__5y6cK","text":"OurMission_text__CwZN9","actions":"OurMission_actions__7mIjC"};